import React from "react";
import OtpInput from "react-otp-input";
import "./otp-input.scss";

export const OTPInput = ({ value, numInputs = 6, onChange, ...props }) => {
  return (
    <OtpInput
      value={value}
      onChange={onChange}
      numInputs={numInputs}
      inputStyle="otp-input"
      placeholder="000000"
      containerStyle={{ gap: "3%" }}
      renderSeparator={<></>}
      renderInput={(props) => <input {...props} />}
      {...props}
      inputType="tel"
    />
  );
};
